import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import NumberField from 'components/forms/new/formikFormFields/NumberField';

const QuantityField = ({ darkMode, errors, touched, mode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.quantity && touched.quantity}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Quantity <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter the quantity for this invoice line.
                    </Text>
                </Box>
                <Box flex="1" minWidth="250px">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '110%',
                            alignItems: 'flex-start',
                            paddingTop: '8px',
                        }}>
                        <VStack width="110%" alignItems="normal">
                            <Field
                                component={NumberField}
                                id="quantity"
                                name="quantity"
                                isDisabled={mode === 'Delete'}
                                validate={(value) =>
                                    (value == null || value === '') &&
                                    'Quantity is required'
                                }
                                darkMode={darkMode}
                            />
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter the invoice line quantity"
                        ariaLabel="quantity-tip"
                        left="25px"
                        top="30px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default QuantityField;
